document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.header');
    const menuToggle = document.querySelector('.header__menu-toggle');

    if (menuToggle && header) {
        menuToggle.addEventListener('click', () => {
            header.classList.toggle('menu-open');
        });
    }
});